import React from 'react';

const Eligibility: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Age Requirements</h4>
      <p>You must be at least 18 years old to use FeelHeard.me. This requirement exists because:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>Our AI is trained to support adult emotional experiences</li>
        <li>Legal capacity to enter into contracts is required</li>
        <li>Complex emotional topics require mature understanding</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Account Requirements</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Provide accurate registration information</li>
        <li>Maintain the security of your account credentials</li>
        <li>One account per person</li>
        <li>No sharing of accounts</li>
      </ul>
    </div>
  );
};

export default Eligibility;